function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import forwardRef from "../../private/forwardRef";
import Text from ".";

/**
 * A shorthand text component which sets up a `h1` using the `largeTitle` typography styles by default.
 *
 * @see [Text documentation](https://construct-kit.reainternal.net/components/web/core/text)
 * */
var H1 = forwardRef((props, ref) => /*#__PURE__*/React.createElement(Text, _extends({
  as: "h1",
  ref: ref
}, props)));

/**
 * A shorthand text component which sets up a `h2` using the `title01` typography styles by default.
 *
 * @see [Text documentation](https://construct-kit.reainternal.net/components/web/core/text)
 * */
var H2 = forwardRef((props, ref) => /*#__PURE__*/React.createElement(Text, _extends({
  as: "h2",
  ref: ref
}, props)));

/**
 * A shorthand text component which sets up a `h3` using the `title02` typography styles by default.
 *
 * @see [Text documentation](https://construct-kit.reainternal.net/components/web/core/text)
 * */
var H3 = forwardRef((props, ref) => /*#__PURE__*/React.createElement(Text, _extends({
  as: "h3",
  ref: ref
}, props)));

/**
 * A shorthand text component which sets up a `h4` using the `title03` typography styles by default.
 *
 * @see [Text documentation](https://construct-kit.reainternal.net/components/web/core/text)
 * */
var H4 = forwardRef((props, ref) => /*#__PURE__*/React.createElement(Text, _extends({
  as: "h4",
  ref: ref
}, props)));

/**
 * A shorthand text component which sets up a `h5` using the `overline` typography styles by default.
 *
 * @see [Text documentation](https://construct-kit.reainternal.net/components/web/core/text)
 * */
var H5 = forwardRef((props, ref) => /*#__PURE__*/React.createElement(Text, _extends({
  as: "h5",
  ref: ref
}, props)));

/**
 * A shorthand text component which sets up a `h6` using the `overline` typography styles by default.
 *
 * @see [Text documentation](https://construct-kit.reainternal.net/components/web/core/text)
 * */
var H6 = forwardRef((props, ref) => /*#__PURE__*/React.createElement(Text, _extends({
  as: "h6",
  ref: ref
}, props)));

/**
 * A shorthand text component which sets up a `p` using the `body01` typography styles by default.
 *
 * @see [Text documentation](https://construct-kit.reainternal.net/components/web/core/text)
 * */
var P = forwardRef((props, ref) => /*#__PURE__*/React.createElement(Text, _extends({
  as: "p",
  ref: ref
}, props)));

/**
 * A shorthand text component which sets up a `small` using the `body02` typography styles by default.
 *
 * @see [Text documentation](https://construct-kit.reainternal.net/components/web/core/text)
 * */
var Small = forwardRef((props, ref) => /*#__PURE__*/React.createElement(Text, _extends({
  as: "small",
  ref: ref
}, props)));

/**
 * A shorthand text component which sets up a `figcaption` using the `caption` typography styles by default.
 *
 * @see [Text documentation](https://construct-kit.reainternal.net/components/web/core/text)
 * */
var FigCaption = forwardRef((props, ref) => /*#__PURE__*/React.createElement(Text, _extends({
  as: "figcaption",
  ref: ref
}, props)));

/**
 * A shorthand text component which sets up a `strong` using the `strong` typography styles.
 *
 * @see [Text documentation](https://construct-kit.reainternal.net/components/web/core/text)
 * */
var Strong = forwardRef((props, ref) => /*#__PURE__*/React.createElement(Text, _extends({
  as: "strong",
  ref: ref
}, props)));
export { H1, H2, H3, H4, H5, H6, P, Small, FigCaption, Strong };